import { baseUrls, apiUrls } from "../../../utils/Endpoints.config";
import { getAxiosConfig, getFomatedError, setFormatedResponse } from "../services/apiService";

/* Create hierarchy Service*/
const createHierarchy = (params) => {
    const { axiosInstance, config } = getAxiosConfig();
    const response = axiosInstance({
        url: `${baseUrls.main}/${apiUrls.admin.createApprovalHierarchy}`,
        method: "POST",
        data: params,
        headers: config.headers || null,
        mode: "no-cors",
    })
        .then((res) => {
            return setFormatedResponse(res);
        })
        .catch((error) => {
            return getFomatedError(error?.response?.data);
        });
    return response;
};

/* Get hierarchy Service*/
const getAllHierarchy = (params) => {
    const { axiosInstance, config, source } = getAxiosConfig();
    const response = axiosInstance({
        url: `${baseUrls.main}/${apiUrls.admin.getHierarchy}`,
        method: "GET",
        params: params,
        headers: config.headers || null,
        mode: "no-cors",
    })
        .then((res) => {
            return setFormatedResponse(res);
        })
        .catch((error) => {
            return getFomatedError(error);
        });
    return response;
};

/* Update Hierarchy Service */
const updateHierarchy = (params) => {
    const { axiosInstance,config } = getAxiosConfig();
    const response = axiosInstance({
      url: `${baseUrls.main}/${apiUrls.admin.updateHierarchy}`,
      method: "PUT",
      data: params,
      headers: config.headers ||null,
      mode: "no-cors",
    })
      .then((res) => {
        return setFormatedResponse(res);
      })
      .catch((error) => {
        return getFomatedError(error);
      });
    return response;
  };


   /* Delete Hierarchy Service */
   const deleteHierarchy = (params) => {
    const { axiosInstance ,config} = getAxiosConfig();
    const response = axiosInstance({
      url: `${baseUrls.main}/${apiUrls.admin.deleteHierarchy}`,
      method: "DELETE",
      data: params,
      headers: config.headers ||null,
      mode: "no-cors",
    })
      .then((res) => {
        return setFormatedResponse(res);
      })
      .catch((error) => {
        return getFomatedError(error?.response?.data);
      });
    return response;
  };


export default {
    createHierarchy,
    getAllHierarchy,
    updateHierarchy,
    deleteHierarchy,

}